// src/utils/rules.ts
export const rules = {
    required: (msg = 'Este campo es obligatorio') => (val: any) => !!val || msg,

    email: (msg = 'Correo inválido') => (val: any) =>
        !val || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) || msg,

    minLength: (length: number, msg?: string) => (val: any) =>
        !val || val.length >= length || msg || `Mínimo ${length} caracteres`,

};
